import { EntityForReportGenerator } from './entity-for-report-generator';

export class GenerateReportsForEntityIds {
  successfullEntities: EntityForReportGenerator[];
  failedEntities: EntityForReportGenerator[];
}
